import { useQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";
import { driversKeys } from "./keys.ts";
import { getDrivers } from "../api.ts";
import type { DriversListResponse } from "../../types.ts";

// Query hook for fetching drivers list
export const useDriversQuery = () => {
  return useQuery<DriversListResponse>({
    queryKey: driversKeys.list(),
    queryFn: async () => {
      const { data } = await getDrivers();
      return data;
    },
    ...reactQueryCacheAndRefetchOptions,
  });
};
